<ng-container [ngSwitch]="elementToRender">
    <button class="mt-3 ms-5" *ngIf="elementToRender != elementsToRender[0]" mat-raised-button (click)="onBackClick()">Back
        <mat-icon>arrow_back</mat-icon>
    </button>

    <app-assistants-list *ngSwitchCase="elementsToRender[0]"></app-assistants-list>
    
    <app-ai-agent-configuration-get-started *ngSwitchCase="elementsToRender[1]"
    (onOutboundClickEvent)="onAgentTypeSelectedEvent(false)" (onInboundClickEvent)="onAgentTypeSelectedEvent(true)"></app-ai-agent-configuration-get-started>

    <div class="container p-4" *ngSwitchCase="elementsToRender[2]">
        <!-- TODO we should render on top which ai agent is being edited -->
        <!-- <div class="row mat-elevation-z2 rounded p-2">
            <div class="col-1 my-auto me-0 pe-0 ms-0 ps-0 text-center">
                <mat-icon>call</mat-icon>
            </div>
            <div class="col-5">
                <p class="fw-bold">Inbound</p>
                <p class="fw-light">ID: 158748948</p>
            </div>
        </div> -->

        <div class="container h-100 d-flex align-items-center p-5" *ngIf="!aiAgent">
            <mat-spinner [diameter]="60" [strokeWidth]="3" class="mx-auto"></mat-spinner>
        </div>

        <div class="row mat-elevation-z2 rounded mt-4" *ngIf="aiAgent">
            
            <div class="col-12">
                <mat-tab-group (selectedTabChange)="onSelectedTabChange($event)" [(selectedIndex)]="selectedIndex" animationDuration="500ms">
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon class="example-tab-icon">dashboard</mat-icon>
                            Dashboard
                        </ng-template>
                        <app-ai-agent-dashboard [aiAgent]="aiAgent"></app-ai-agent-dashboard>
                    </mat-tab>
                    <mat-tab class="h-100">
                        <ng-template mat-tab-label>
                            <mat-icon class="example-tab-icon">lightbulb_outline</mat-icon>
                            Knowledge
                        </ng-template>
                        <app-knowledge-base [aiAgent]="aiAgent"></app-knowledge-base>
                    </mat-tab>
                    <mat-tab class="h-100">
                        <ng-template mat-tab-label>
                            <mat-icon class="example-tab-icon">settings</mat-icon>
                            Configure
                        </ng-template>
                        <app-ai-agent-configuration [aiAgent]="aiAgent"></app-ai-agent-configuration>
                    </mat-tab>
                    <mat-tab class="h-100">
                        <ng-template mat-tab-label>
                            <mat-icon class="example-tab-icon">airline_stops</mat-icon>
                            Integrations
                        </ng-template>
                        <app-integrations [aiAgent]="aiAgent"></app-integrations>
                    </mat-tab>
                    <mat-tab class="h-100" *ngIf="aiAgent.agentType =='OUTBOUND'">
                        <ng-template mat-tab-label>
                            <mat-icon class="example-tab-icon">campaign</mat-icon>
                            Campaigns
                        </ng-template>
                        <app-outboud-campaigns [aiAgent]="aiAgent"></app-outboud-campaigns>
                    </mat-tab>
                    <mat-tab class="h-100" *ngIf="aiAgent.agentType =='OUTBOUND'">
                        <ng-template mat-tab-label>
                            <mat-icon class="example-tab-icon">phone_missed</mat-icon>
                            Auto Call Back
                        </ng-template>
                        <app-missed-outbound-calls [aiAgent]="aiAgent"></app-missed-outbound-calls>
                    </mat-tab>
                    <mat-tab class="h-100">
                        <ng-template mat-tab-label>
                            <mat-icon class="example-tab-icon">add_ic_call</mat-icon>
                            Transfers
                        </ng-template>
                        <app-transfer [aiAgent]="aiAgent"></app-transfer>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon class="example-tab-icon">save</mat-icon>
                            Call Logs
                        </ng-template>
                        <app-call-log-tab [aiAgent]="aiAgent"></app-call-log-tab>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon class="example-tab-icon">swap_calls</mat-icon>
                            Call flows
                        </ng-template>
                        <app-diagram-flow [aiAgent]="aiAgent"></app-diagram-flow>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</ng-container>